__turbopack_context__.v({
  "auto_close": "CommonPopup-module-scss-module__9B5PRG__auto_close",
  "button": "CommonPopup-module-scss-module__9B5PRG__button",
  "button_group": "CommonPopup-module-scss-module__9B5PRG__button_group",
  "close": "CommonPopup-module-scss-module__9B5PRG__close",
  "dialog": "CommonPopup-module-scss-module__9B5PRG__dialog",
  "dimmed": "CommonPopup-module-scss-module__9B5PRG__dimmed",
  "dismiss": "CommonPopup-module-scss-module__9B5PRG__dismiss",
  "footer": "CommonPopup-module-scss-module__9B5PRG__footer",
  "light": "CommonPopup-module-scss-module__9B5PRG__light",
  "pass_through": "CommonPopup-module-scss-module__9B5PRG__pass_through",
  "popup": "CommonPopup-module-scss-module__9B5PRG__popup",
  "popup_button": "CommonPopup-module-scss-module__9B5PRG__popup_button",
  "popup_content": "CommonPopup-module-scss-module__9B5PRG__popup_content",
  "shareholders_meeting": "CommonPopup-module-scss-module__9B5PRG__shareholders_meeting",
  "shareholders_meeting_text": "CommonPopup-module-scss-module__9B5PRG__shareholders_meeting_text",
  "shareholders_meeting_title": "CommonPopup-module-scss-module__9B5PRG__shareholders_meeting_title",
  "sticky_popup": "CommonPopup-module-scss-module__9B5PRG__sticky_popup",
  "wrapper": "CommonPopup-module-scss-module__9B5PRG__wrapper",
});
